import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';

import olStylesText from 'ol/ol.css';

import Map from 'ol/Map.js';
import OSM from 'ol/source/OSM.js';
import TileLayer from 'ol/layer/Tile.js';
import View from 'ol/View.js';
import { fromLonLat, toLonLat } from 'ol/proj'
import { Text, Fill, Stroke } from 'ol/style';
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import { Style, Icon } from 'ol/style'
import XYZ from 'ol/source/XYZ'
import Collection from 'ol/Collection';
import { defaults as defaultControls } from 'ol/control'

import { artistProfileElement, artistDirectoryElement, getDataFromApi } from './artistutils'
import { favouritesEl } from './favourites'

export class ArtistProfile {

    constructor(artistProfileEl, artistDirectoryEl) {
        const markerSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><path fill="red" d="M256 0C160 0 82 78 82 174c0 101 80 164 123 239 42 75 42 102 51 102s9-27 51-99c43-75 123-138 123-239C430 78 352 0 256 0zm0 240c-37 0-67-30-67-67 0-37 30-67 67-67s67 30 67 67c0 37-30 67-37 67z"/><circle cx="256" cy="174" r="67" fill="rgba(0,0,0,0.01)"/></svg>`; // Opacity 0.01 looks see through but allows for capturing click
        this.markerSVGUrl = 'data:image/svg+xml;base64,' + btoa(markerSVG);
        const url = new URL(window.location.href);
        this.baseUrl = url.href;

        this.artistProfileEl = artistProfileEl
        this.artistDirectoryEl = artistDirectoryEl
        //console.log("dirEl", this.artistDirectoryEl)
        window.addEventListener('resize', () => {
            if (this.swiper) {
                this.swiper.update();
            }
        });
        this.mapEl = document.querySelector(".map")
        const styleElement = document.createElement("style")
        styleElement.innerText = olStylesText
        this.markerLayer = new VectorLayer({
            source: new VectorSource()
        })
        this.mapEl.parentElement.appendChild(styleElement)
        const esriBase = new TileLayer({
            source: new XYZ({
                url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
                attributions: 'Sources: Esri, HERE, Garmin, © OpenStreetMap contributors, and the GIS User Community'
            })
        });
        const names = new TileLayer({
            source: new XYZ({
                url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
                attributions: 'Sources: Esri, HERE, Garmin, © OpenStreetMap contributors, and the GIS User Community',
            })
        })
        this.map = new Map({
            target: this.mapEl,
            interactions: new Collection(), // Disable pan, zoom etc
            controls: defaultControls({ zoom: false }), // remove buttons
            layers: [
                esriBase,
                names,
                this.markerLayer,
            ],
            view: new View({
                center: [0, 0],
                zoom: 2,
            })
        });
        this.handleBackButton()
        this.handleEditButton()
    }

    async setEditButton(artist) {
        const editBlk = this.artistProfileEl.querySelector(".editing")
        if (editBlk) {
            editBlk.style.display = "none"
            if (artist.key && await getDataFromApi("ArtistApi", "isauthorised", artist.key)) {
                editBlk.style.display = "flex"
            }
        }
    }

    handleEditButton() {
        const editBtn = this.artistProfileEl.querySelector(".editbutton")
        if (editBtn) {
            const btn = editBtn.querySelector("button")
            btn.addEventListener("click", (e) => {
                e.preventDefault()
                window.location.href = editBtn.dataset.href + `?artistid=${this.artist.id}`
            })
        }
    }

    togglePageContent(show) {
        document.querySelectorAll("main > div, main .grid__item__container").forEach(panel => {
            if (panel.querySelector(".artist-directory") === null) {
                panel.style.display = show ? "" : "none";
            } else if (panel.classList.contains("grid__item__container")) {
                const gridArea = panel.querySelector(".grid__area");
                if (gridArea) gridArea.style.position = "relative";
            }
        });

        const patterns = document.querySelectorAll(".showpattern");
        const backgrounds = document.querySelectorAll(".bgimg");

        if (!show) {
            patterns.forEach(el => el.classList.add("hidepattern"));
            backgrounds.forEach(el => el.style.display = "none");
        } else {
            patterns.forEach(el => el.classList.remove("hidepattern"));
            backgrounds.forEach(el => el.style.display = "");
        }
    }

    setLogo(artist) {
        const logoPanel = this.artistProfileEl.querySelector(".logo")
        logoPanel.style.display = "none"
        if (artist.logo) {
            console.log("SETLOGO", artist.logo)
            logoPanel.style.backgroundImage = `url('${artist.logo}')`
            logoPanel.style.display = "block"
        }
    }

    setSocialLinks(artist) {
        const socialPanel = this.artistProfileEl.querySelector(".socialbuttons")
        socialPanel.style.display = "none"
        const socialButtons = socialPanel.querySelectorAll("a")
        socialButtons.forEach((a) => {
            a.style.display = "none"
        })
        //console.log(artist.socialMediaLinks)
        if (artist.socialMediaLinks && artist.socialMediaLinks.length) {
            socialPanel.style.display = "block"
            artist.socialMediaLinks.forEach((link) => {
                let btn = null
                //console.log(link, link.includes("facebook"))
                if (link.includes("facebook")) {
                    btn = socialPanel.querySelector(".facebook")
                }
                if (link.includes("linked")) {
                    btn = socialPanel.querySelector(".linkedin")
                }
                if (link.includes("tube")) {
                    btn = socialPanel.querySelector(".youtube")
                }
                if (link.includes("insta")) {
                    btn = socialPanel.querySelector(".instagram")
                }
                if (btn) {
                    btn.style.display = ""
                    btn.href = link
                }
            })
        }
    }

    setMediums(artist) {
        const mediumsPanel = this.artistProfileEl.querySelector(".mediums")
        mediumsPanel.style.display = "none"
        const value = (artist.artisticMedium ? artist.artisticMedium : "") + (artist.secondaryArtisticMedium ? ", " + artist.secondaryArtisticMedium : "")
        if (value) {
            mediumsPanel.style.display = ""
            mediumsPanel.querySelector(".value").innerText = value
        }
    }

    setListingId(artist) {
        const panel = this.artistProfileEl.querySelector(".listingid")
        panel.style.display = "none"
        const value = parseInt(artist.listingNumber)
        if (value) {
            panel.style.display = ""
            panel.querySelector(".value").innerText = "#" + value
        }
    }

    getBadgeElement(icon, name, iconIsUrl) {
        const element = document.createElement("div")
        const url = iconIsUrl ? icon : `/img/ArtsTrail/icons/${icon}`
        element.innerHTML = `<div><img src="${url}" alt="${name}"> <span class="label">${name}</span></div>`
        return element
    }

    getBadges(artist) {
        const badges = [];
        if (artist.awardWinning) {
            badges.push(this.getBadgeElement("award-winning.svg", "Award winning artist"))
        }
        if (artist.newToTrail) {
            badges.push(this.getBadgeElement("new-to-trail.svg", "New to trail"))
        }
        if (artist.accessible == 'Wheelchair/ baby buggy accessible') {
            badges.push(this.getBadgeElement("accessible.svg", "Wheelchair and buggy accessible"))
        }
        if (artist.openLabourDay) {
            badges.push(this.getBadgeElement("open-labour-day.svg", "Open on Monday (Labour Day)"))
        }
        if (artist.openYearRound) {
            badges.push(this.getBadgeElement("open-year-round.svg", "Open year round"))
        }
        const valuedImageUrl = this.artistDirectoryEl.closest(".artist-container").dataset.valuedmemberimage
        console.log("viu", valuedImageUrl)
        if (artist.valuedMember && valuedImageUrl) {
            badges.push(this.getBadgeElement(valuedImageUrl, "20+ year artist", true))
        }
        return badges;
    }

    setBadges(artist) {
        const panel = this.artistProfileEl.querySelector(".badges")
        panel.style.display = "none"
        panel.innerHTML = ""
        const badgeEl = document.createElement("div")
        const badges = this.getBadges(artist);
        if (badges.length) {
            if (badges.length > 3) {
                badgeEl.classList.add("bgrid")
            }
            panel.style.display = ""
            badges.forEach(badge => {
                badgeEl.append(badge)
            })
        }
        //console.log("badge", badgeEl)
        panel.append(badgeEl)


    }

    // setValuedMember(artist) {
    //     const panel = this.artistProfileEl.querySelector(".valuedmember")
    //     panel.style.display = "none"
    //     const container = panel.closest(".overview-container")
    //     container.classList.remove("valued-member")
    //     if (artist.valuedMember) {
    //         panel.style.display = ""
    //         container.classList.add("valued-member")
    //     }
    // }

    setDescription(artist) {
        const panel = this.artistProfileEl.querySelector(".description")
        panel.style.display = "none"
        if (artist.description) {
            panel.style.display = ""
            panel.querySelector(".value").innerHTML = artist.description
        }

    }

    setAwards(artist) {
        const panel = this.artistProfileEl.querySelector(".awards")
        panel.style.display = "none"
        const valueEl = panel.querySelector(".value")
        valueEl.innerHTML = ""
        if (artist.awards && artist.awards.length) {
            panel.style.display = ""
            artist.awards.forEach((award) => {
                const awardsEl = document.createElement("div")
                const awardsText = award.year + " | " + award.awardName + " | " + award.organisation
                awardsEl.innerText = awardsText
                valueEl.append(awardsEl)
            })
        }
    }

    setPanelValue(className, value) {
        const panel = this.artistProfileEl.querySelector(`.${className}`)
        panel.style.display = "none"
        const valueEl = panel.querySelector(".value")
        valueEl.innerHTML = ""
        if (value) {
            panel.style.display = ""
            panel.querySelector(".value").innerHTML = value
        }
    }

    setGallery(artist) {
        const panel = this.artistProfileEl.querySelector(".swiper");
        const wrapper = panel.querySelector(".swiper-wrapper");

        // 1. Clear previous slides
        wrapper.innerHTML = "";
        panel.style.display = "none";

        if (artist.images && artist.images.length > 0) {
            panel.style.display = "";

            artist.images.forEach((image) => {
                // 2. Create the required swiper-slide container
                const slide = document.createElement("div");
                slide.classList.add("swiper-slide");

                const imageEl = document.createElement("img");
                imageEl.src = image.url;

                slide.append(imageEl);
                wrapper.append(slide);
            });

            if (artist.images.length > 4) {
                // add duplicates to fix swiper nav
                artist.images.forEach((image) => {
                    // 2. Create the required swiper-slide container
                    const slide = document.createElement("div");
                    slide.classList.add("swiper-slide");

                    const imageEl = document.createElement("img");
                    imageEl.src = image.url;

                    slide.append(imageEl);
                    wrapper.append(slide);
                });
            }

            // 3. Tell Swiper to recalculate slides and sizes
            if (this.swiper) {
                this.swiper.update();
                this.swiper.slideTo(0, 0); // Reset to first slide
            }
        }
    }

    setupMap(artist) {
        const panel = this.artistProfileEl.querySelector(".map-container");
        panel.style.display = "none";
        if (artist.coords) {
            panel.style.display = "block";
            const coords = typeof artist.coords === 'string'
                ? JSON.parse(artist.coords)
                : artist.coords;

            const source = this.markerLayer.getSource();
            source.clear();
            const lon = parseFloat(coords.longitude);
            const lat = parseFloat(coords.latitude);
            const transformedCoords = fromLonLat([lon, lat])
            const artistStyle = new Style({
                image: new Icon({
                    anchor: [0.5, 1],
                    src: this.markerSVGUrl,
                    scale: 0.08
                }),
                text: new Text({
                    text: `${artist.name}\n${artist.location}`, // \n creates a new line
                    textAlign: 'center',
                    textBaseline: 'bottom',
                    offsetY: -45, // Moves text above the SVG (adjust based on scale)
                    font: 'bold 12px sans-serif',
                    fill: new Fill({ color: '#f00' }),
                    padding: [2, 5, 2, 5]
                })
            });
            const marker = new Feature({
                geometry: new Point(transformedCoords),
            });
            marker.setStyle(artistStyle);
            source.addFeature(marker);
            this.map.updateSize();
            const view = this.map.getView()
            //console.log(lon, lat)
            view.setCenter(transformedCoords);
            view.setZoom(16)



        }
    }

    getMetaValue(name) {
        return document.querySelector(`meta[name="${name}"]`) ? document.querySelector(`meta[name="${name}"]`).getAttribute("content") : null;
    }

    setMetaValue(name, value) {
        const metaTag = document.querySelector(`meta[name="${name}"]`);
        if (metaTag) {
            metaTag.setAttribute("content", value);
        }
    }

    getOgValue(name) {
        return document.querySelector(`meta[property="og:${name}"]`) ? document.querySelector(`meta[property="og:${name}"]`).getAttribute("content") : null;
    }

    setOgValue(name, value) {
        const metaTag = document.querySelector(`meta[property="og:${name}"]`);
        if (metaTag) {
            metaTag.setAttribute("content", value);
        }
    }

    getTwitterValue(name, value) {
        return document.querySelector(`meta[property="twitter:${name}"]`) ? document.querySelector(`meta[property="twitter:${name}"]`).getAttribute("content") : null;
    }

    setTwitterValue(name, value) {
        const metaTag = document.querySelector(`meta[property="twitter:${name}"]`);
        if (metaTag) {
            metaTag.setAttribute("content", value);
        }
    }

    storeOriginalDocument() {
        this.canonicalUrl = document.querySelector('link[rel="canonical"]') ? document.querySelector('link[rel="canonical"]').getAttribute("href") : null;
        this.originalTitle = document.title;
        this.originalMetaDescription = this.getMetaValue("description")
        this.originalOgTitle = this.getOgValue("title")
        this.originalOgDescription = this.getOgValue("description")
        this.originalOgUrl = this.getOgValue("url")
        this.originalOgImage = this.getOgValue("image")
        this.originalTwitterTitle = this.getTwitterValue("title")
        this.originalTwitterDescription = this.getTwitterValue("description")
        this.originalTwitterImage = this.getTwitterValue("image")
        this.originalTwitterUrl = this.getTwitterValue("url")
    }

    setupDocument(artist) {
        const url = window.location.href.split('?')[0] + `?artist=${artist.nameInUrl.replace(/:+$/, "")}`
        //console.log("setupDocument", url)
        document.querySelector('link[rel="canonical"]').setAttribute("href", url)
        document.title = artist.fullName
        this.setMetaValue("description", artist.teaser ? artist.teaser : "")
        this.setOgValue("title", artist.fullName)
        this.setOgValue("description", artist.teaser ? artist.teaser : "")
        this.setOgValue("url", url)
        this.setOgValue("image", artist.logo ? window.location.origin + artist.logo : "")
        this.setTwitterValue("title", artist.fullName)
        this.setTwitterValue("description", artist.teaser ? artist.teaser : "")
        this.setTwitterValue("image", artist.logo ? window.location.origin + artist.logo : "")
        this.setTwitterValue("url", url)
    }

    unsetDocument() {
        document.querySelector('link[rel="canonical"]').setAttribute("href", this.canonicalUrl)
        document.title = this.originalTitle
        this.setMetaValue("description", this.originalMetaDescription)
        this.setOgValue("title", this.originalOgTitle)
        this.setOgValue("description", this.originalOgDescription)
        this.setOgValue("url", this.originalOgUrl)
        this.setOgValue("image", this.originalOgImage)
        this.setTwitterValue("title", this.originalTwitterTitle)
        this.setTwitterValue("description", this.originalTwitterDescription)
        this.setTwitterValue("image", this.originalTwitterImage)
        this.setTwitterValue("url", this.originalTwitterUrl)
    }

    setFavouritesLink(artist) {
        // Only allow add to favourites when artist is approved (artist not approved can happen in edit context)
        this.artistProfileEl.classList.remove("not-approved")
        if (!artist.approved) {
            this.artistProfileEl.classList.add("not-approved")
        }
    }

    setUpProfile(artist) {
        console.log("Artist to profile", artist)

        //  Cater for favourites
        this.artistProfileEl.setAttribute("data-artistid", artist.id)
        this.artistProfileEl.querySelector(".artist-itinerary").setAttribute("data-artistid", artist.id)
        favouritesEl.updateDom()

        this.artistProfileEl.style.display = "block"
        this.setupDocument(artist)
        this.setLogo(artist)
        this.togglePageContent(false)
        this.setSocialLinks(artist)
        this.setMediums(artist)
        this.setListingId(artist)
        this.setBadges(artist)
        //this.setValuedMember(artist)
        this.setDescription(artist)
        this.setAwards(artist)
        this.setGallery(artist)
        this.setFavouritesLink(artist)
        this.setPanelValue("address", artist.address)
        this.setPanelValue("mobile", artist.mobilePhone)
        const email = artist.emailOverride ? artist.emailOverride : artist.email;
        this.setPanelValue("email", artist.hideEmail ? "" : email)
        let websiteLink = null;
        const websiteUrl = artist.websiteUrl
        if (websiteUrl && websiteUrl.startsWith("http")) {
            websiteLink = `<a href="${artist.websiteUrl}" target="_blank" rel="noopener noreferrer">${artist.websiteUrl}</a>`
        }
        this.setPanelValue("websiteUrl", websiteLink)
        this.setPanelValue("paymentOptions", artist.paymentOptions)
        this.setPanelValue("openingTimes", artist.openingTimes)
        this.setPanelValue("accessible", artist.accessible)
        this.setupMap(artist)
        this.setEditButton(artist)
        this.artistProfileEl.querySelector(".name").innerText = artist.fullName
        window.scrollTo(0, 0);

        if (!this.swiper) {
            //console.log("setting up swiper")
            this.swiper = new Swiper('.artist-profile .swiper', {
                modules: [Navigation],
                slidesPerView: 'auto', // Fits as many as possible based on slide width
                spaceBetween: 20,      // The gap between slides in pixels
                loop: true,
                navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
                observer: true, // change when images change
                observeParents: true,
                loopAddBlankSlides: true, // Automatically injects virtual spaces to balance the math
                loopAdditionalSlides: 5,   // Forces rendering of boundary slides
                updateOnImagesReady: true,
                resizeObserver: true,
                roundLengths: true,
            });
            this.swiper.update();
        }

    }

    setToArtistList(ad, id) {
        //console.log(ad)
        ad.togglePageContent(true)
        document.title = ad.originalTitle
        ad.artistProfileEl.style.display = "none"
        //console.log("set to list", ad.artistDirectoryEl)
        ad.artistDirectoryEl.style.display = "block"
        if (id) {
            const artistEl = ad.artistDirectoryEl.querySelector(`.artist[data-artistid="${id}"]`)
            if (artistEl) {
                const header = document.querySelector('.header-container');
                const headerHeight = header.offsetHeight;
                const elementPosition = artistEl.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = elementPosition - 2 * headerHeight;
                window.scrollTo({
                    top: offsetPosition
                });
            }
        }
    }

    handleBackButton() {
        // NOTE: IF logged in as artist OR ADMIN backbutton.classList.contains("artist-access") == true
        // So goes back to bare URL
        const backbutton = this.artistProfileEl.querySelector(".backbutton button")
        backbutton.addEventListener("click", (e) => {
            e.preventDefault()
            this.unsetDocument()
            if (backbutton.classList.contains("artist-access")) {
                window.location = this.baseUrl.split('?')[0] // Artists can access own content but when going back to the list will load only active artists
            } else {
                console.log("dispatching event")
                const backToList = new Event('directory:backtolist');
                document.dispatchEvent(backToList);
            }
        })
    }

    async handleUrl(ad) {
        //console.log("handleUrl", ad, this.artist)
        const oldArtistId = this.artist ? this.artist.id : null;
        this.artist = null
        ad.artistDirectoryEl.style.display = "none"
        ad.artistProfileEl.style.display = "none"
        const params = new URLSearchParams(window.location.search);
        const artistName = params.get('artist');
        const artistId = params.get('artistid');
        if (artistName) {
            const artist = await getDataFromApi("ArtistApi", "detail", artistName)
            if (artist) {
                this.artist = artist
                ad.setUpProfile(artist)
            } else {
                ad.setToArtistList(ad, oldArtistId)
            }
        } else {
            if (artistId) {
                const artist = await getDataFromApi("ArtistApi", "detailfromid", artistId)
                if (artist) {
                    this.artist = artist
                    ad.setUpProfile(artist)
                } else {
                    ad.setToArtistList(ad, oldArtistId)
                }
            } else {
                ad.setToArtistList(ad, oldArtistId)
            }
        }
    }

    init() {
        this.storeOriginalDocument()
        const ad = this
        this.handleUrl(ad)
        //console.log("setting up push/pop handlers")
        window.addEventListener('pushState', () => { console.log("pushState"); this.handleUrl(ad) });
        window.addEventListener('replaceState', () => { console.log("replaceState"); this.handleUrl(ad) });
        window.addEventListener('popstate', () => { console.log("popstate"); this.handleUrl(ad) });
    }
}

export let profile = null
const artistProfileEl = artistProfileElement();
const artistDirectoryEl = artistDirectoryElement();
if (artistProfileEl && artistDirectoryEl) {
    profile = new ArtistProfile(artistProfileEl, artistDirectoryEl);
    profile.init()
}
